// Utils

import { urlTools } from '../../utils/tools/urlTools';

// Constants
import endpointConfig from '../../../config/app.json';
import customEndpoints from './customEndpoints';

const customConfigName = __CUSTOM_CONFIG__ ? __CUSTOM_CONFIG__ : null;

const endpointsConfig = endpointConfig.globalConfig;

const productionEndpoints = urlTools.getEndpoints({
    endpointsConfig,
    customConfigName
});

export const urlChunks = {
    HOUSEHOLD_ID: 'householdId',
    INBOX_SEARCH: '&subject=${subject}',
    USER_ID: 'userId',
};

export default {
    ...productionEndpoints,
    ...customEndpoints,
};
